import { CoverageAddress } from 'hydra-data-types';
import { isNonEmptyString } from 'ts-utils';
import { UserDataState } from '../store/userData/UserDataState';

/**
 * The Places selection is stored one component per user-data key, like every other assessment
 * answer, and reassembled where the object shape is needed (the coverage check, screen prefill).
 * Optional components are written as empty arrays so a re-selected address without a unit number
 * doesn't keep the previous one.
 */
export function toCoverageAddressUserData(address: CoverageAddress): UserDataState {
  return {
    coverageAddressLine1: [address.line1],
    coverageAddressLine2: address.line2 === undefined ? [] : [address.line2],
    coverageAddressCity: [address.city],
    coverageAddressState: [address.state],
    coverageAddressPostalCode: [address.postalCode],
    coverageAddressPlaceId: address.placeId === undefined ? [] : [address.placeId],
    coverageAddressFormatted: [address.formattedAddress],
  };
}

/** The stored address, or `undefined` until every required component is present. */
export function getCoverageAddress(userData: UserDataState): CoverageAddress | undefined {
  const line1 = userData.coverageAddressLine1?.[0];
  const city = userData.coverageAddressCity?.[0];
  const state = userData.coverageAddressState?.[0];
  const postalCode = userData.coverageAddressPostalCode?.[0];
  const formattedAddress = userData.coverageAddressFormatted?.[0];
  if (
    !isNonEmptyString(line1) ||
    !isNonEmptyString(city) ||
    !isNonEmptyString(state) ||
    !isNonEmptyString(postalCode) ||
    !isNonEmptyString(formattedAddress)
  ) {
    return undefined;
  }

  const line2 = userData.coverageAddressLine2?.[0];
  const placeId = userData.coverageAddressPlaceId?.[0];
  return {
    line1,
    ...(isNonEmptyString(line2) ? { line2 } : {}),
    city,
    state,
    postalCode,
    ...(isNonEmptyString(placeId) ? { placeId } : {}),
    formattedAddress,
  };
}
